import React from 'react';
import classNames from 'classnames';

type SkeletonVariant = 'rounded' | 'circular' | 'rectangular';
type SkeletonAnimation = false | 'animate-pulse' | 'animate-shimmer' | string;

type BaseSkeletonProps = {
  animation?: SkeletonAnimation;
  className?: string;
};

type CircularProps = {
  variant: 'circular';
  width: number | string;
  height: number | string;
} & BaseSkeletonProps;

type RoundedProps = {
  variant: 'rounded' | 'rectangular';
  width?: number | string;
  height?: number | string;
} & BaseSkeletonProps;

export type SkeletonProps = CircularProps | RoundedProps;

export const Skeleton: React.FC<SkeletonProps> = ({
  variant = 'rounded',
  width = '100%',
  height = 'auto',
  animation = false,
  className,
}) => {
  return (
    <div
      style={{ width, height }}
      className={classNames(
        `bg-neutral-100 relative overflow-hidden my-2`,

        variantStyles(variant),
        skeletonAnimation(animation),
        className
      )}
    />
  );
};

function variantStyles(variant: SkeletonVariant) {
  switch (variant) {
    case 'circular':
      return 'rounded-full';
    case 'rounded':
      return 'rounded';
    case 'rectangular':
      return 'rounded-none';
  }
}

function skeletonAnimation(animation: SkeletonAnimation) {
  switch (animation) {
    case 'animate-pulse':
      return 'animate-pulse';
    case 'animate-shimmer':
      return 'after:absolute after:top-0 after:bottom-0 after:left-0 after:right-0 after:bg-gradient-to-r after:from-transparent after:via-neutral-400/10 after:to-transparent after:-translate-x-full after:animate-shimmerMove';
    case false:
      return '';
    default:
      return animation;
  }
}
